export const DiscordIcon = (
  <svg
    className=""
    fill="#FFFFFF"
    style={{ height: "20px", width: "30px" }}
    viewBox="0 0 22 16"
  >
    <path d="M8.11.5c-.28.002-2.574.067-4.996 1.873 0 0-2.584 4.665-2.584 10.408 0 0 1.507 2.593 5.473 2.719 0 0 .664-.792 1.202-1.477-2.278-.685-3.14-2.108-3.14-2.108s.18.126.502.307c.018 0 .035.019.07.036.055.035.108.054.162.09.448.252.896.45 1.31.611.736.307 1.615.576 2.639.774 1.346.252 2.925.342 4.646.019a12.954 12.954 0 002.603-.774 10.118 10.118 0 002.062-1.063s-.896 1.458-3.247 2.125c.538.666 1.185 1.439 1.185 1.439 3.965-.126 5.473-2.72 5.473-2.7 0-5.746-2.584-10.409-2.584-10.409C16.32.446 13.861.5 13.861.5l-.251.288c3.05.918 4.468 2.27 4.468 2.27a14.856 14.856 0 00-5.4-1.711 15.048 15.048 0 00-3.626.036c-.107 0-.197.019-.306.035-.628.072-2.153.288-4.073 1.135-.663.288-1.059.505-1.059.505S5.088 1.635 8.317.717L8.137.5h-.028zm-.457 6.645c1.022 0 1.849.882 1.83 1.981 0 1.1-.808 1.982-1.83 1.982-1.005 0-1.83-.883-1.83-1.982s.806-1.981 1.83-1.981zm6.55 0c1.004 0 1.83.882 1.83 1.981 0 1.1-.809 1.982-1.83 1.982-1.006 0-1.83-.883-1.83-1.982s.806-1.981 1.83-1.981z"></path>
  </svg>
);

export const InstagramIcon = (
  <svg
    className=""
    fill="#FFFFFF"
    style={{ height: "20px", width: "30px" }}
    viewBox="0 0 24 24"
  >
    <path d="M15.75 2H8.25C4.79875 2 2 4.79875 2 8.25V15.75C2 19.2012 4.79875 22 8.25 22H15.75C19.2012 22 22 19.2012 22 15.75V8.25C22 4.79875 19.2012 2 15.75 2ZM20.125 15.75C20.125 18.1625 18.1625 20.125 15.75 20.125H8.25C5.8375 20.125 3.875 18.1625 3.875 15.75V8.25C3.875 5.8375 5.8375 3.875 8.25 3.875H15.75C18.1625 3.875 20.125 5.8375 20.125 8.25V15.75Z"></path>
    <path d="M12 7C9.23875 7 7 9.23875 7 12C7 14.7613 9.23875 17 12 17C14.7613 17 17 14.7613 17 12C17 9.23875 14.7613 7 12 7ZM12 15.125C10.2775 15.125 8.875 13.7225 8.875 12C8.875 10.2763 10.2775 8.875 12 8.875C13.7225 8.875 15.125 10.2763 15.125 12C15.125 13.7225 13.7225 15.125 12 15.125Z"></path>
    <path d="M17.375 7.29124C17.743 7.29124 18.0413 6.99295 18.0413 6.62499C18.0413 6.25703 17.743 5.95874 17.375 5.95874C17.0071 5.95874 16.7088 6.25703 16.7088 6.62499C16.7088 6.99295 17.0071 7.29124 17.375 7.29124Z"></path>
  </svg>
);

export const TwitterIcon = (
  <svg
    className=""
    fill="#FFFFFF"
    style={{ height: "20px", width: "30px" }}
    viewBox="0 0 18 16"
  >
    <path d="M.09 13.791c1.992.14 3.728-.344 5.327-1.571-.816-.098-1.527-.311-2.127-.786-.584-.466-1.032-1.047-1.272-1.841h1.48c.008-.033.016-.066.024-.107-.816-.237-1.512-.663-2.032-1.342-.52-.67-.775-1.448-.8-2.3.52.148 1.016.295 1.52.434.016-.033.04-.065.056-.098-.72-.606-1.24-1.334-1.431-2.275a3.92 3.92 0 01.391-2.7c2 2.389 4.511 3.715 7.598 3.936-.096-.778-.104-1.498.16-2.202.912-2.463 3.983-3.249 5.894-1.481.216.196.4.229.632.147.632-.229 1.255-.474 1.903-.72-.248.81-.784 1.408-1.415 1.989.615-.164 1.231-.336 1.839-.5.024.025.048.041.072.066-.464.491-.912 1.007-1.415 1.449-.272.237-.36.458-.376.818-.144 4.01-1.752 7.25-5.175 9.289-3.487 2.07-7.077 1.947-10.612-.025-.064-.04-.12-.09-.24-.18z"></path>
  </svg>
);

export const YoutubeIcon = (
  <svg
    className=""
    fill="#FFFFFF"
    style={{ height: "20px", width: "30px" }}
    viewBox="0 0 20 18"
  >
    <path d="M9.99433 3.33325C9.99433 3.33325 4.26441 3.33326 2.82628 3.70695C2.05625 3.9221 1.4222 4.55617 1.20704 5.33752C0.833352 6.77565 0.833344 9.75391 0.833344 9.75391C0.833344 9.75391 0.833352 12.7435 1.20704 14.159C1.4222 14.9403 2.04493 15.563 2.82628 15.7782C4.27574 16.1632 9.99433 16.1632 9.99433 16.1632C9.99433 16.1632 15.7356 16.1632 17.1737 15.7895C17.9551 15.5744 18.5778 14.963 18.7816 14.1703C19.1666 12.7435 19.1666 9.76524 19.1666 9.76524C19.1666 9.76524 19.178 6.77565 18.7816 5.33752C18.5778 4.55617 17.9551 3.93344 17.1737 3.72961C15.7356 3.33327 9.99433 3.33325 9.99433 3.33325ZM8.17116 7.00225L12.9386 9.75391L8.17116 12.4942V7.00225Z"></path>
  </svg>
);

export const MailIcon = (
  <svg
    className=""
    fill="#FFFFFF"
    style={{ height: "20px", width: "30px" }}
    viewBox="0 0 24 24"
  >
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"></path>
  </svg>
);

export const ListIcon = (
  <svg
    width="63"
    height="55"
    viewBox="0 0 63 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="20.644" y="20.4805" width="24" height="2" rx="1" fill="#091713" />
    <rect x="20.644" y="26.4805" width="24" height="2" rx="1" fill="#091713" />
    <rect x="20.644" y="32.4805" width="24" height="2" rx="1" fill="#091713" />
  </svg>
);

export const MediumIcon = (
  <svg
    width="20"
    height="30"
    viewBox="0 0 256 146"
    fill="none"
    version="1.1"
    preserveAspectRatio="xMidYMid"
  >
    <g>
      <path
        d="M72.2009141,1.42108547e-14 C112.076502,1.42108547e-14 144.399375,32.5485469 144.399375,72.6964154 C144.399375,112.844284 112.074049,145.390378 72.2009141,145.390378 C32.327779,145.390378 0,112.844284 0,72.6964154 C0,32.5485469 32.325326,1.42108547e-14 72.2009141,1.42108547e-14 Z M187.500628,4.25836743 C207.438422,4.25836743 223.601085,34.8960455 223.601085,72.6964154 L223.603538,72.6964154 C223.603538,110.486973 207.440875,141.134463 187.503081,141.134463 C167.565287,141.134463 151.402624,110.486973 151.402624,72.6964154 C151.402624,34.9058574 167.562834,4.25836743 187.500628,4.25836743 Z M243.303393,11.3867175 C250.314,11.3867175 256,38.835526 256,72.6964154 C256,106.547493 250.316453,134.006113 243.303393,134.006113 C236.290333,134.006113 230.609239,106.554852 230.609239,72.6964154 C230.609239,38.837979 236.292786,11.3867175 243.303393,11.3867175 Z"
        fill="#ffffff"
      />
    </g>
  </svg>
);

export const GlobeIcon = (
  <svg
    version="1.0"
    width="30"
    height="30"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0,100) scale(0.1,-0.1)"
      fill="#ffffff"
      stroke="none"
    >
      <path
        d="M358 937 c-187 -65 -304 -219 -316 -414 -11 -197 108 -380 296 -454
82 -33 242 -33 324 0 125 49 231 158 275 283 25 73 25 223 0 296 -44 125 -151
235 -275 283 -89 33 -218 36 -304 6z m118 -215 c-3 -3 -34 -1 -68 4 -59 8 -63
10 -60 34 4 38 53 112 92 138 l35 23 3 -97 c1 -53 0 -99 -2 -102z m134 127
c27 -38 56 -106 48 -114 -1 -2 -33 -6 -70 -10 l-68 -7 0 101 0 102 30 -16 c17
-9 44 -34 60 -56z m-240 46 c0 -2 -13 -26 -30 -52 -16 -26 -30 -52 -30 -57 0
-6 -4 -17 -9 -25 -7 -11 -17 -10 -62 4 l-53 18 39 34 c51 45 145 95 145 78z
m330 -26 c32 -17 70 -43 85 -59 l27 -28 -52 -17 c-44 -15 -54 -15 -61 -4 -5 8
-9 19 -9 25 0 5 -13 31 -30 57 -44 70 -43 70 40 26z m-475 -141 c53 -20 56
-23 51 -49 -3 -16 -8 -58 -12 -94 l-7 -65 -90 0 -89 0 7 48 c9 60 62 182 79
182 2 0 30 -10 61 -22z m652 -48 c18 -36 35 -86 39 -112 l6 -48 -89 0 -90 0
-7 65 c-4 36 -9 78 -12 94 -5 26 -2 29 48 49 29 11 58 20 63 18 6 -1 24 -31
42 -66z m-464 5 l67 -7 0 -79 0 -79 -91 0 -92 0 7 63 c11 95 18 119 31 114 6
-3 42 -8 78 -12z m270 -12 c3 -16 9 -56 13 -90 l7 -63 -92 0 -91 0 0 79 0 78
73 10 c39 6 75 11 78 12 4 0 9 -11 12 -26z m-419 -258 c4 -36 9 -78 12 -94 5
-26 3 -29 -52 -49 -39 -14 -62 -18 -70 -11 -19 16 -62 121 -69 172 l-7 47 89
0 90 0 7 -65z m216 -14 l0 -79 -67 -7 c-36 -4 -72 -9 -78 -12 -13 -5 -20 19
-31 115 l-7 62 92 0 91 0 0 -79z m216 17 c-11 -96 -18 -120 -31 -115 -6 3 -42
8 -78 12 l-67 7 0 79 0 79 91 0 92 0 -7 -62z m219 15 c-7 -52 -50 -156 -70
-173 -9 -7 -29 -4 -70 12 l-57 22 6 35 c3 20 9 62 13 94 l6 57 90 0 89 0 -7
-47z m-435 -253 l0 -101 -29 16 c-45 23 -111 121 -111 164 0 9 35 16 108 19
l32 2 0 -100z m173 81 c21 -21 -54 -140 -104 -166 l-29 -16 0 102 0 102 63 -7
c34 -4 66 -11 70 -15z m-344 -43 c7 -18 23 -50 37 -71 14 -22 23 -41 21 -44
-8 -8 -100 44 -142 80 l-39 34 44 16 c63 22 67 21 79 -15z m455 16 l47 -16
-26 -28 c-29 -30 -143 -95 -151 -87 -3 3 6 22 20 44 14 21 30 53 37 71 13 37
11 37 73 16z"
      />
    </g>
  </svg>
);

export const ShareIcon = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.5453 0C27.9775 0.3234 29.2579 0.891 30.2149 2.079C32.1223 4.455 31.8451 7.7616 29.5417 9.8538C27.4231 11.7744 23.9845 11.6424 21.9055 9.5568C21.7537 9.405 21.6019 9.2466 21.4237 9.0618C18.3943 10.8174 15.3847 12.5664 12.3355 14.3352C12.8899 15.7872 12.8965 17.2128 12.3355 18.6582C15.3847 20.427 18.4009 22.176 21.4369 23.9382C22.5259 22.6776 23.8261 21.9252 25.4827 21.8064C28.3141 21.6018 31.0003 23.6544 31.3897 26.3868C31.8385 29.5416 29.9443 32.3136 26.9611 32.868C26.8225 32.8944 26.6905 32.9538 26.5519 33C26.0635 33 25.5751 33 25.0867 33C24.3277 32.6964 23.5159 32.4786 22.8229 32.0628C21.0145 30.9936 19.5427 28.3668 20.6647 25.2318C17.6551 23.4828 14.6323 21.7272 11.6161 19.9782C8.71206 23.166 4.97646 22.3608 3.11526 20.4204C0.976857 18.1896 1.03626 14.7048 3.22746 12.5136C5.14146 10.5996 8.89686 10.0122 11.5897 13.0746C14.5927 11.319 17.6155 9.5568 20.6647 7.7748C20.2753 6.5868 20.0905 5.4186 20.4403 4.2306C21.0937 2.0328 22.5127 0.6402 24.7699 0.1386C24.8623 0.1056 24.9679 0.0462 25.0801 0C25.5685 0 26.0569 0 26.5453 0ZM21.7141 5.643C21.7075 7.9002 23.5819 9.7878 25.8457 9.8076C28.0897 9.8208 29.9905 7.9332 30.0037 5.676C30.0169 3.4254 28.1425 1.5246 25.8787 1.5048C23.6413 1.485 21.7207 3.399 21.7141 5.643ZM25.8655 31.5216C28.1293 31.5216 30.0103 29.634 30.0037 27.3768C29.9971 25.0998 28.1293 23.2386 25.8589 23.2386C23.6017 23.2386 21.7141 25.1262 21.7207 27.3834C21.7207 29.6406 23.6083 31.5282 25.8655 31.5216ZM11.2729 16.5C11.2729 14.2692 9.41826 12.4146 7.16106 12.3816C4.90386 12.3486 2.98986 14.2296 2.97666 16.5C2.96346 18.7572 4.86426 20.6646 7.12146 20.6646C9.38526 20.6646 11.2795 18.7638 11.2729 16.5Z"
      fill="black"
    />
  </svg>
);
